import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  /* flex: 1; */
  /* margin: 2px; */
  //
`;

export const Dropdown = styled.div<{ $active: boolean }>`
  position: absolute;
  top: 100%;
  right: 0px;
  left: 0px;
  background: ${({ theme }) => theme.palette.white};
  width: 100%;
  box-shadow: ${({ theme }) => theme.boxShadow.md};
  transform: translateY(10px);
  background: ${({ theme }) => theme.palette.boxBackgroundDark};
  border: 1px solid ${({ theme }) => theme.palette.primary};
  border-radius: 0 0 2px 2px;
  max-height: 200px;
  overflow: auto;
  ${({ $active }) =>
    $active
      ? css`
          visibility: visible;
          opacity: 1;
          z-index: 1;
          transform: translateY(0);
        `
      : css`
          visibility: hidden;
          opacity: 0;
          z-index: -1;
          transition: 0.2s;
        `}
`;

export const DropdownLoading = styled.div`
  height: 80px;
`;

export const DropdownItem = styled.div`
  width: 100%;
  .button-content {
    justify-content: flex-start;
    color: ${({ theme }) => theme.palette.primary};
  }

  &:not(&:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.palette.middGray};
  }
`;
